import script from "./NavFbochasComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NavFbochasComponent.vue?vue&type=script&setup=true&lang=js"

import "./NavFbochasComponent.vue?vue&type=style&index=0&id=2d07f094&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d07f094"]])

export default __exports__